// Dipende da src/components/animations/useScrollPin.js del progetto (stack
// scroll-experience). Import via alias '@' — mai relativo, i blocchi sono
// file condivisi copiati in components/_vs/blocks/ a profondità variabile.
import { useMagneticHover } from '@/components/animations/useScrollPin';
import { Heading } from './Heading';
import { SlideMedia } from './SlideMedia';

/**
 * @param {{
 *   mediaType?: 'image' | 'video', image?: string, imageAlt?: string, videoUrl?: string,
 *   showOverlay?: boolean, eyebrow?: string, title?: string, subtitle?: string,
 *   cta?: string, ctaHref?: string, headingLevel?: number,
 * }} props
 */
export function HeroBlock({
  mediaType = 'image', image, imageAlt = '', videoUrl, showOverlay = true,
  eyebrow, title, subtitle, cta, ctaHref = '#', headingLevel = 1,
}) {
  const btnRef = useMagneticHoverSafe();
  const hasMedia = mediaType === 'video' ? !!videoUrl : !!image;
  return (
    <section className={'relative min-h-screen flex items-center px-6 md:px-16 overflow-hidden' + (hasMedia ? '' : ' vs-gradient-mesh')}>
      {hasMedia && (
        <>
          {/* headingLevel 1 = questo blocco è il primo della pagina (vedi
              BlockRenderer): probabile immagine LCP, carica subito e con
              priorità; altrimenti lazy, è più in basso nella pagina —
              rilevante solo per un'immagine, un video incorporato non
              compete comunque per l'LCP allo stesso modo. */}
          <SlideMedia
            mediaType={mediaType}
            image={image}
            imageAlt={imageAlt}
            videoUrl={videoUrl}
            fallbackAlt={title}
            className="-z-10"
            loading={headingLevel === 1 ? 'eager' : 'lazy'}
            fetchpriority={headingLevel === 1 ? 'high' : 'auto'}
          />
          {showOverlay && <div className="absolute inset-0 bg-black/35 -z-10" />}
        </>
      )}
      {showOverlay && (
        <div className="max-w-3xl">
          {eyebrow && (
            <p className={'text-xs tracking-[0.14em] uppercase mb-6 ' + (hasMedia ? 'text-white/70' : 'text-theme-text-subtle')}>{eyebrow}</p>
          )}
          {title && (
            <Heading level={headingLevel} className={'font-heading text-display font-light tracking-tight leading-[1.05] mb-8 whitespace-pre-line ' + (hasMedia ? 'text-white' : 'text-theme-text')}>
              {title}
            </Heading>
          )}
          {subtitle && (
            <p className={'text-body-lg max-w-xl leading-relaxed mb-10 ' + (hasMedia ? 'text-white/85' : 'text-theme-text-muted')}>{subtitle}</p>
          )}
          {cta && (
            <a
              ref={btnRef}
              href={ctaHref}
              className="inline-flex items-center px-7 py-3 rounded-lg bg-theme-accent text-theme-accent-text text-sm font-medium tracking-wide"
            >
              {cta}
            </a>
          )}
        </div>
      )}
    </section>
  );
}

// useMagneticHover vive nel progetto (dipende da GSAP locale) — import
// relativo fallisce in Storybook/preview isolate: fallback no-op.
function useMagneticHoverSafe() {
  try {
    return useMagneticHover();
  } catch {
    return { current: null };
  }
}
